document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-global-header]');
const navigation = document.querySelector('#PrimaryNavigation');
const menuToggle = document.querySelector('[data-menu-toggle]');
const dropdowns = document.querySelectorAll('.header__dropdown');

menuToggle?.addEventListener('click', () => {
  const isOpen = navigation?.classList.toggle('is-open');
  menuToggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
  menuToggle.setAttribute('aria-label', isOpen ? 'Menu sluiten' : 'Menu openen');
});

dropdowns.forEach((dropdown) => {
  dropdown.addEventListener('toggle', () => {
    if (!dropdown.open) return;
    dropdowns.forEach((other) => {
      if (other !== dropdown) other.removeAttribute('open');
    });
  });
});

document.addEventListener('click', (event) => {
  if (header?.contains(event.target)) return;
  dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
  navigation?.classList.remove('is-open');
  menuToggle?.setAttribute('aria-expanded', 'false');
});

document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
  const input = selector.querySelector('input');
  const minus = selector.querySelector('[data-quantity-minus]');
  const plus = selector.querySelector('[data-quantity-plus]');
  const update = (delta) => {
    const minimum = Number(input.min || 1);
    input.value = String(Math.max(minimum, Number(input.value || minimum) + delta));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  minus?.addEventListener('click', () => update(-1));
  plus?.addEventListener('click', () => update(1));
});

const moveGalleryToMedia = (mediaId) => {
  if (!mediaId) return;
  const gallery = document.querySelector('[data-product-gallery]');
  const slides = gallery ? [...gallery.querySelectorAll('[data-gallery-slide]')] : [];
  const targetIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
  const targetSlide = targetIndex >= 0 ? slides[targetIndex] : null;
  if (!gallery || !targetSlide) return;
  const galleryBox = gallery.getBoundingClientRect();
  const slideBox = targetSlide.getBoundingClientRect();
  const left = gallery.scrollLeft + slideBox.left - galleryBox.left;
  gallery.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  document.querySelectorAll('[data-gallery-dot]').forEach((dot, index) => dot.setAttribute('aria-current', String(index === targetIndex)));
};

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const wrap = gallery.closest('.product-gallery-wrap');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const dots = [...wrap.querySelectorAll('[data-gallery-dot]')];
  const setActive = (index) => dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
  dots.forEach((dot, index) => dot.addEventListener('click', () => {
    const slide = slides[index];
    if (!slide) return;
    const galleryBox = gallery.getBoundingClientRect();
    const slideBox = slide.getBoundingClientRect();
    const left = gallery.scrollLeft + slideBox.left - galleryBox.left;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    gallery.scrollTo({ left, behavior });
  }));
  gallery.addEventListener('scroll', () => {
    if (!gallery.clientWidth) return;
    setActive(Math.round(gallery.scrollLeft / gallery.clientWidth));
  }, { passive: true });
});

document.querySelectorAll('[data-product-option-selectors]').forEach((picker) => {
  const form = picker.closest('.product-form');
  const section = picker.closest('.product-main');
  const info = picker.closest('.product-main__info');
  const variantsScript = picker.querySelector('[data-product-variants-json]');
  const hiddenVariant = picker.querySelector('[data-selected-variant-id]');
  const selects = [...picker.querySelectorAll('[data-product-option-select]')];
  if (!variantsScript || !hiddenVariant || !selects.length) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    return;
  }

  const getSelectedValues = () => selects.map((select) => select.value);
  const findVariant = (values) => variants.find((variant) => variant.options.every((value, index) => value === values[index]));

  const updateAvailability = () => {
    const selectedValues = getSelectedValues();
    selects.forEach((select, optionIndex) => {
      [...select.options].forEach((option) => {
        const possible = variants.some((variant) => {
          if (!variant.available || variant.options[optionIndex] !== option.value) return false;
          return variant.options.every((value, index) => index === optionIndex || value === selectedValues[index]);
        });
        option.disabled = !possible;
      });
    });
  };

  const updateVariant = () => {
    const values = getSelectedValues();
    let variant = findVariant(values);

    if (!variant) {
      variant = variants.find((candidate) => candidate.available && candidate.options.every((value, index) => value === values[index]));
    }
    if (!variant) return;

    hiddenVariant.value = variant.id;
    hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));

    const price = info?.querySelector('[data-product-price]');
    const comparePrice = info?.querySelector('[data-product-compare-price]');
    const mainButton = form?.querySelector('[data-main-cart-button]');
    const stickyButton = section?.querySelector('[data-sticky-cart-button]');
    const stickyPrice = section?.querySelector('[data-sticky-price]');

    if (price) price.textContent = variant.price;
    if (comparePrice) {
      comparePrice.textContent = variant.comparePrice || '';
      comparePrice.hidden = !variant.comparePrice;
    }
    if (stickyPrice) stickyPrice.textContent = variant.price;
    [mainButton, stickyButton].forEach((button) => {
      if (!button) return;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'In winkelwagen' : 'Uitverkocht';
    });

    moveGalleryToMedia(variant.mediaId);
    if (window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    updateAvailability();
  };

  selects.forEach((select) => select.addEventListener('change', updateVariant));
  updateAvailability();
});

document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
  const url = section.dataset.url;
  if (!url) return;
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const recommendations = documentFragment.querySelector('[data-product-recommendations]');
      if (recommendations?.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
    })
    .catch(() => {});
});

document.querySelectorAll('[data-sticky-cart]').forEach((stickyCart) => {
  const mainButton = document.querySelector('[data-main-cart-button]');
  if (!mainButton || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(([entry]) => {
    stickyCart.hidden = false;
    stickyCart.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0.15 });
  observer.observe(mainButton);
});
